export default __webpack_public_path__ + "static/media/checkBlue.c9bbf9bb.svg";